const Sunset = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none">
  <path d="M9.08594 5.74984C9.65939 6.33982 11.1857 8.6665 12.0026 8.6665M14.9193 5.74984C14.3458 6.33982 12.8195 8.6665 12.0026 8.6665M12.0026 8.6665V1.6665" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M19.4219 9.4082L17.772 11.0581" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  <path d="M1.5026 16.833H3.83594" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  <path d="M4.57665 9.40819L6.22656 11.0581" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  <path d="M22.5 16.833H20.1667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  <path d="M22.5 20.333H1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  <path d="M16.6693 16.8332C16.6693 14.2558 14.5799 12.1665 12.0026 12.1665C9.42528 12.1665 7.33594 14.2558 7.33594 16.8332" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
  );
  
  export default Sunset;